// Action Types
import {createAction, handleActions} from "redux-actions";

const SET_INQUIRYLIST = 'inquiry/SET_INQUIRYLIST';
const SET_TOTAL = 'inquiry/SET_TOTAL';
const SET_SIZE = 'inquiry/SET_SIZE';
const SET_PAGE = 'inquiry/SET_PAGE';

const SET_DETAIL = 'inquiry/SET_DETAIL';

export const setInquiryList = createAction(SET_INQUIRYLIST);
export const setTotal = createAction(SET_TOTAL);
export const setSize = createAction(SET_SIZE);
export const setPage = createAction(SET_PAGE);
export const setDetailInquiry = createAction(SET_DETAIL);



const initalState = {
    detailInquiry: {
        categoryName: '',
        title: '',
        content: '',
        createdAt: '',
        answer: '',
        files: [],
        answerFiles: [],
    },
    inquiryList: [],
    total: 0,
    size: 10,
    page: 1
}

export default handleActions({
    [SET_INQUIRYLIST]: (state, action) => ({
        ...state,
        inquiryList: action.payload,
    }),
    [SET_TOTAL]: (state, action) => ({
        ...state,
        total: action.payload
    }),
    [SET_SIZE]: (state, action) => ({
        ...state,
        size: action.payload
    }),
    [SET_PAGE] : (state, action) => ({
        ...state,
        page: action.payload
    }),
    [SET_DETAIL]: (state, action) => ({
        ...state,
        detailInquiry: {...action.payload}
    })
}, initalState);
